import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';
import { AuthService } from '../shared/auth.service';

// The quote editor only for who may quote (#1697): Quotes on for the company and
// Admin or the Quotes grant. The API stays 403 behind Gate 'quote'; this only avoids
// a dead page with a raw error. Waits for the user like AuthGuard does.
@Injectable({ providedIn: 'root' })
export class CanQuoteGuard {
  constructor(private auth: AuthService, private router: Router) {}

  canActivate(): Observable<boolean | UrlTree> {
    return this.auth.user.pipe(
      filter(Boolean),
      take(1),
      map((user: any) => user.can_quote && user.quotes_enabled ? true : this.router.createUrlTree(['/users/me'])),
    );
  }
}
